/* system.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 18 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M10,13.9c0-0.2,0-0.6,0-0.7H8c0,0.2,0,0.5,0,0.7c0,1.7-4.5,1.4-4.5,1.4c0,0.2-0.2,0.4,0,0.6C3.6,15.9,3.8,16,4,16h10
                    c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0-0.4,0-0.6C14.4,15.3,10,15.1,10,13.9z"/>
                <path class="foreground-gl" d="M17.4,0H0.6C0.2,0,0,0.3,0,0.6v7.1v0.2v4.2c0,0.3,0.2,0.6,0.6,0.6h16.9c0.3,0,0.6-0.3,0.6-0.6V0.6C18,0.3,17.8,0,17.4,0z
                     M16.8,10.5c0,0.2-0.2,0.4-0.4,0.4H1.6c-0.2,0-0.4-0.2-0.4-0.4l0-2.9h0l0-6c0-0.2,0.2-0.4,0.4-0.4l15.2,0c0,0,0,0,0,0V10.5z"/>
            </g>
            </svg>
         `
};
